<template>
  <el-scrollbar>
    <el-menu default-active="/home" router unique-opened :class="{ fold: props.fold }">
      <template v-for="menu in filterMenusByAuth()" :key="menu.index">
        <template v-if="menu.children">
          <el-sub-menu :index="menu.index">
            <template #title>
              <el-icon :title="menu.title">
                <component :is="menu.icon" />
              </el-icon>

              <span class="item-title">{{ menu.title }}</span>
            </template>

            <el-menu-item v-for="child in menu.children" :key="child.index" :index="child.index">
              <el-icon :title="child.title">
                <component :is="child.icon" />
              </el-icon>

              <span class="item-title">{{ child.title }}</span>
            </el-menu-item>
          </el-sub-menu>
        </template>

        <template v-else>
          <el-menu-item :index="menu.index">
            <el-icon :title="menu.title">
              <component :is="menu.icon" />
            </el-icon>

            <span class="item-title">{{ menu.title }}</span>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </el-scrollbar>
</template>

<script setup>
import { useAuthStore } from '@/store/auth'

const props = defineProps({
  fold: {
    type: Boolean,
    default: false
  }
})

const menus = [
  {
    title: '主页',
    icon: 'House',
    index: '/home',
    auth: true
  },
  {
    title: '系统管理',
    icon: 'Setting',
    index: '/system',
    children: [
      {
        title: '公司管理',
        icon: 'Histogram',
        index: '/company'
      },
      {
        title: '系统用户',
        icon: 'User',
        index: '/adminUser'
      },
      {
        title: '内置角色',
        icon: 'UserFilled',
        index: '/role'
      },
      {
        title: '培训文件',
        icon: 'Document',
        index: '/resource'
      },
      {
        title: '风险标识',
        icon: 'Picture',
        index: '/riskIcon'
      },
      {
        title: '票据模板',
        icon: 'Tickets',
        index: '/ticketTemplate'
      },
      {
        title: '排查表',
        icon: 'List',
        index: '/checkList'
      },
      {
        title: '试题管理',
        icon: 'Notebook',
        index: '/question'
      }
    ],
    auth: ['company', 'adminUser', 'role', 'resource', 'riskIcon', 'ticketTemplate', 'checkList', 'question']
  },
  {
    title: '客户管理',
    icon: 'Avatar',
    index: '/customer',
    children: [
      {
        title: '商务咨询',
        icon: 'ChatDotRound',
        index: '/crm/inquiry'
      },
      {
        title: '销售线索',
        icon: 'Connection',
        index: '/crm/lead'
      },
      {
        title: '客户档案',
        icon: 'User',
        index: '/crm/customer'
      },
      {
        title: '商机管理',
        icon: 'TrendCharts',
        index: '/crm/opportunity'
      },
      {
        title: '合同管理',
        icon: 'Document',
        index: '/crm/contract'
      },
      {
        title: '订单管理',
        icon: 'Goods',
        index: '/crm/order'
      }
    ],
    auth: ['crm/inquiry', 'crm/lead', 'crm/customer', 'crm/opportunity', 'crm/contract', 'crm/order']
  }
]

const authStore = useAuthStore()

function filterMenusByAuth() {
  const list = []
  for (const group of menus) {
    if (!hasAuth(group)) continue
    const { ...copy } = group
    if (copy.children) {
      copy.children = copy.children.filter((it) => hasAuth(it))
      for (const child of copy.children) {
        if (child.mix) {
          //此时需要调整index值，因为默认值可能已经不适用(无权限)
          child.index = '/' + child.auth.filter((it) => authStore.has(it))[0]
        }
      }
    }
    list.push(copy)
  }
  return list
}

function hasAuth(menuItem) {
  const { auth, index } = menuItem
  return (
    auth === true ||
    //未定义auth属性时取值index（即路由uri）
    (auth === undefined && authStore.has(index.substring(1))) ||
    //auth为字符串时
    (typeof auth === 'string' && authStore.has(auth)) ||
    //auth为字符串数组时，任意一项通过则通过
    (Array.isArray(auth) && authStore.hasAny(auth))
  )
}
</script>

<style lang="scss" scoped>
.el-menu {
  border-right: 0;
  --el-menu-active-color: var(--my-bg-color-secondary);
  --el-menu-text-color: var(--my-text-color);
  --el-menu-hover-text-color: var(--my-text-color);
  --el-menu-bg-color: var(--my-bg-color);
  --el-menu-hover-bg-color: var(--my-bg-color-secondary);
}
.el-menu.fold {
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-menu-item {
    padding: 0;
  }
  .el-icon {
    margin-right: auto;
    margin-left: auto;
  }
  .item-title {
    display: none;
  }
  &:deep(.el-sub-menu__title) {
    padding: 0;
  }
  &:deep(.el-sub-menu__icon-arrow) {
    display: none;
  }
}
.el-menu-item.is-active {
  background-color: var(--my-bg-color-secondary);
  color: var(--my-text-color);
}
.el-scrollbar {
  flex: 1;
  width: 100%;
}
.item-title {
  user-select: none;
}
</style>
